<!-- https://raw.githubusercontent.com/MatteoGabriele/vue-speech/master/src/component/speech.vue -->
<template>
    <div>
        <v-container fluid>

            <v-layout>
                <v-flex sm12>
                    <v-card color="grey lighten-3">
                        <v-card-title primary-title>
                            <h3 class="headline mb-0">Techlab: Spracherkennung</h3> <br />
                        </v-card-title>

                        <v-card-text>

                            Nachfolgende Demo ermöglicht einen kurzen Einblick in die Potentiale der Spracherkennung.
                            Bei Bedarf erläutern wir Möglichkeiten und Grenzen gerne im Detail. Bitte beachten sie beim Testen, dass die Erkennung
                            serverseitig erfolgt und Ihre Daten den Browser verlassen. 
                            Technische Details entnehmen Sie der Eventliste. 
                            <br /><br />
                            <b>Weitere Hinweise:</b>
                            <ul><li>Die Erkennungssprache ist derzeit auf "Deutsch" eingestellt.</li>
                                <li>Die gesprochen Wörter "Punkt", "Fragezeichen", "Ausrufezeichen" und "Komma" werden als Satzzeichen interpretiert.</li>
                                <li>Versuchen sie jeweils einen Satz zu sprechen und machen Sie dann eine kurze Pause</li>
                                <li>Beenden der Aufnahme sagen sie "Stop", nachdem der erkannte Text blau hinterlegt ist, oder nutzen den Button.</li>
                                <li>Die Erkennung endet, wenn keine Sprache erkannt wird, spätestens aber nach dreissig Sekunden.</li>

                            </ul>


                        </v-card-text>

                        <!-- Not needed now
                        <v-card-actions>
                            <v-btn flat color="orange">Share</v-btn>
                            <v-btn flat color="orange">Explore</v-btn>
                        </v-card-actions>
                            -->
                    </v-card>
                </v-flex>
            </v-layout> <!-- text zeile -->


            <v-layout row wrap mt-3>
                <v-flex sm12 md6>
                    <h4>Erkennungsergebnis</h4>
                    <v-textarea id="idText"
                                name="input-7-1"
                                box
                                label=" "
                                auto-grow
                                clearable
                                v-bind:value='uiText'>

                    </v-textarea>
                    <v-btn color="primary" small :disabled="startDisabled" v-on:click="uiEvent('start')">Erkennung starten</v-btn>
                    <v-btn color="primary" small :disabled="stopDisabled" v-on:click="uiEvent('stop')">Erkennung beenden</v-btn>
                    <p class="body-1" style="margin-left:7px">{{uiStatusMessage}}</p>
                </v-flex> <!-- Spalte Erkennung -->
                <v-flex sm12 md6 pl-2>
                    <h4>Events ({{events.length}})</h4>
                    <v-data-table :headers="headers"
                                  :items="events"
                                  :loading="loading"
                                  :pagination.sync="pagination"
                                  class="elevation-1">

                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                            <td class="text-xs-left">{{ props.item.eventname }}</td>
                            <td class="text-xs-right">{{ props.item.time }}</td>
                            <td class="text-xs-left">{{ props.item.runtimeTranscription }}</td>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog"
                  max-width="290">
            <v-card>
                <v-card-title class="headline">Keine Sprache erkannt.</v-card-title>

                <v-card-text>
                    Es konnte keine Spracheingabe erkannt werden.
                    Bitte prüfen Sie die Einstellungen des Mikrofons und die Internetverbindung.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1"
                           flat="flat"
                           @click="dialog = false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogChrome"
                  max-width="290">
            <v-card>
                <v-card-title class="headline">Nutzen Sie Chrome</v-card-title>

                <v-card-text>
                    Die Spracherkennung funktioniert am besten mit dem Chrome Browser.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1"
                           flat="flat"
                           @click="dialogChrome = false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>

    import { MySpeechRecognition } from './../classes/MySpeechRecognition.js';
    import { isNullOrUndefined } from "util";

    export default {

        props: {
            lang: {
                type: String,
                default: 'de-de'
            }
        },

        data: () => ({
            // Helper
            starttime: -1,
            startDisabled: false,
            stopDisabled: true,


            // Hold the instance of speechrtecogniton
            speechRecognitionInstance: null,

            // Controls the dialog
            dialog: false,
            dialogChrome: false,

            // Hold the text displayed in the UI
            uiText: '',
            uiStatusMessage: "Keine Aufnahme.",

            transscriptNew: '',
            transcriptHistory: '',


            // Helper to manage the state
            isRecording: false,
            isWorking: false,

            // Recording events coming from the store
            events: [],

            // Table
            loading: false,

            pagination: {
                sortBy: 'time',
                descending: true,
                rowsPerPage: -1
            },

            headers: [
                {
                    text: 'Event',
                    align: 'left',
                    sortable: false,
                    value: 'eventname',
                },

                {
                    text: 'Zeit (ms)',
                    align: 'left',
                    value: 'time',
                },
                {
                    text: 'Erkannter Text',
                    align: 'left',
                    sortable: false,
                    value: 'runtimeTranscription',
                },

            ]
        }),

        methods: {
            uiEvent(event) {
                switch (event) {
                    case "start": // return to landing page
                        this.startRecording();
                        return;

                    case "stop": // return to landing page
                        this.stopRecording();
                        return;
                }
            },

            stopRecording() {

                this.isRecording = false;
                this.loading = false;

                this.startDisabled = false;
                this.stopDisabled = true;

                this.uiStatusMessage = "Erkennung beendet.";
                this.speechRecognitionInstance.stop();

            },

            startRecording() {
                this.starttime = -1;
                this.isRecording = true;

                this.loading = true;

                this.startDisabled = true;
                this.stopDisabled = false;

                this.events = [];
                this.runtimeTranscription = "";
                this.transcriptHistory = '',
                    this.uiStatusMessage = "Sprechen Sie. Warte ... ";

                this.speechRecognitionInstance.start();
            },

            processNewText(legacyText, newText) {

                if (newText.includes("Stop") || newText.includes("stop")) {
                    console.log("STOPP command recognized.");
                    this.stopRecording();
                    return '';
                }

                // Kein bisheriger Text: Erstes Zeichen auf Uppercase und return.
                if (legacyText.length == 0) {
                    return newText.substring(0, 1).toUpperCase() + newText.substring(1);
                }

                // Make first char uppercase if prevLine ended with dot, add a space...
                var l = legacyText.length;
                var lastChar = legacyText.substring(l - 1, l);

                if (lastChar == '.' || lastChar == '?' || lastChar == '!') {

                    newText =  newText.substring(0, 1).toUpperCase() + newText.substring(1);

                }

                return ' ' + newText;


               

            }
        },

        computed: {
            classObject: function () {
                return {
                    active: true,
                    'special-text': true
                }
            }
        },

        destroyed() {
            console.log("SPEECH TO TEXT.VUE: destroyed ");
        },


        mounted() {
            console.log("SPEECH TO TEXT.VUE: mounted() ");
                  

            this.events = [];
            if (speechWatcher) console.log("SPEECH TO TEXT.VUE: Speechwatcher exists. ");
            let speechWatcher = this.$store.watch(
                this.$store.getters.speechAPI,
                (event) => {

                    console.log("\n\n... EVENT .... " + JSON.stringify(event));


                    // Process this event in a special routine, as it is not a regular speech event..
                    if (event.eventname === "nospeech") {

                        this.dialogChrome = true;
                        this.startDisabled = true;
                        this.stopDisabled = true;
                        this.uiStatusMessage = "Bitte nutzen Sie Chrome, zum Testen der Spracherkennung."
                        return;

                    }


                    if (!this.isRecording) {
                        console.log("Ignored event, because reconding is stopped:  " + event.eventname);
                        this.uiStatusMessage = "Erkennung beendet.";
                        return;
                    }

                    // Logging Tabelle füllen
                    if (this.starttime < 0) this.starttime = event.time;
                    event.time = event.time - this.starttime;

                    let correctedText, success, idText;
                    

                    switch (event.eventname) {

                        case 'nospeech':
                            // Disable the start button
                            this.startDisabled = true;
                            break;

                        case 'onaudiostart':
                            this.uiStatusMessage = "Sprechen Sie weiter ..."
                            break;

                        case 'onspeechstart':
                            this.isWorking = true;
                            this.uiStatusMessage = "Sie sprechen ..."
                            break;

                        case 'onspeechend':
                            this.uiStatusMessage = ""
                            break;

                        case 'result':

                            // Process the text
                            correctedText = this.processNewText(this.transcriptHistory, event.runtimeTranscription);

                            // Intermediate result, just update the displayed text
                            this.uiText = this.transcriptHistory + correctedText;

                            // If we receive a result, w know that the mic is working...
                            this.isWorking = true;
                            this.uiStatusMessage = "Sprache wird erkannt ..."
                            break;

                        case 'onerror':

                            // Wenn noch kein Text erkannt wurde, und on error kommmt, dann zeigen wir den Dialog...
                            if (!this.isWorking) {
                                this.dialog = true;
                            }

                            // ... und beenden die Aufnahme.
                            this.stopRecording();
                            break;

                        case 'onend':
                            // Recording ended. Save result and start new.

                            // Run text management of raw recognized text
                            correctedText = this.processNewText(this.transcriptHistory, event.runtimeTranscription);


                            this.transcriptHistory += correctedText;
                            this.uiText = this.transcriptHistory;

                            idText = document.getElementById("idText");
                            idText.select();
                            success = document.execCommand('copy');
                            console.log("SUCCESS -----------> " + success);

                            // Restart recording, if under 30 seconds, stop otherwise
                            if (event.time < 30000) {
                                this.speechRecognitionInstance.start();
                            }
                            else {
                                this.stopRecording();
                            }
                            break;
                    }

                    this.events.push(event);

                });

            this.speechRecognitionInstance = new MySpeechRecognition('de');


            if (this.speechRecognitionInstance === isNullOrUndefined) {
                // Display the dialofg ..
                this.dialogChrome = true;
                this.startDisabled = true;
                this.stopDisabled = true;

            }
        }
    }
</script>

<style scoped>
</style>
